import request from "@/utils/axios";

export const getImageUrlAPI = (data) => {
  return request({
    url: "/file/staticResources/staticRes",
    method: "post",
    data,
  });
}